package core.extensions

import core.enums.ELocalizationKeys
import core.localization.Localization

val ELocalizationKeys.localized: String
    get() = Localization.getLocalizationKey(this)